__turbopack_context__.v({
  "className": "jetbrains_mono_db12079e-module__vazLUW__className",
});
